import { render } from "./CurrentMapStats.vue?vue&type=template&id=7bcc07aa&scoped=true"
import script from "./CurrentMapStats.vue?vue&type=script&lang=js"
export * from "./CurrentMapStats.vue?vue&type=script&lang=js"

import "./CurrentMapStats.vue?vue&type=style&index=0&id=7bcc07aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcc07aa"]])

export default __exports__